export enum CustomBrandingType {
  StandardMessage,
  InvoiceMessage,
  QuoteMessage,
  GuestPortalMessage,
  InvoiceLogo
}
